/**
 * Figma Node IDs:
 * Design Frame: 4:13742
 * Instance IDs: I4:13736, I4:13764, I840:12315
 * Composite: true
 * Last Updated: 2024-12-22
 * Generated by: Claude Code figma-component command
 */
import React from "react";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { useIntl } from "react-intl";
import {
  imageContainerClass,
  imageClass,
  FigureClass,
  imageWithoutCaptionClass,
  imageCaptionClass,
} from "./Figure.css";

export interface FigureProps {
  src: string;
  altText: string;
  caption?: string;
  imageId?: string;
  captionId?: string;
  containerBgColor?: string;
}

export const Figure: React.FC<FigureProps> = ({
  src,
  altText,
  caption,
  imageId,
  captionId,
  containerBgColor,
}) => {
  const hasCaption = caption && caption.trim() !== "";
  const imageClassName = `${imageClass} ${hasCaption ? FigureClass : imageWithoutCaptionClass}`;
  const intl = useIntl();
  return (
    <div
      className={imageContainerClass}
      style={
        containerBgColor ? { backgroundColor: containerBgColor } : undefined
      }
    >
      <img
        id={imageId}
        src={src}
        alt={
          altText
            ? intl.formatMessage({
                id: altText,
                defaultMessage: altText,
                description: "Alt text for the image",
              })
            : ""
        }
        className={imageClassName}
      />
      {hasCaption && (
        <p id={captionId} className={imageCaptionClass}>
          <RichText value={caption} />
        </p>
      )}
    </div>
  );
};

export default Figure;
